module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-atmosphere-pool.0523be1c.jpg";